"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnershipCompany$ = exports.OwnershipCompany$outboundSchema = exports.OwnershipCompany$inboundSchema = void 0;
exports.ownershipCompanyToJSON = ownershipCompanyToJSON;
exports.ownershipCompanyFromJSON = ownershipCompanyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.OwnershipCompany$inboundSchema = z.object({
    address_1: z.nullable(z.string()),
    address_2: z.nullable(z.string()),
    address_3: z.nullable(z.string()),
    company_name: z.nullable(z.string()),
    country_incorporated: z.nullable(z.string()),
    proprietorship_category: z.nullable(z.string()),
    registration_no: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_1": "address1",
        "address_2": "address2",
        "address_3": "address3",
        "company_name": "companyName",
        "country_incorporated": "countryIncorporated",
        "proprietorship_category": "proprietorshipCategory",
        "registration_no": "registrationNo",
    });
});
/** @internal */
exports.OwnershipCompany$outboundSchema = z.object({
    address1: z.nullable(z.string()),
    address2: z.nullable(z.string()),
    address3: z.nullable(z.string()),
    companyName: z.nullable(z.string()),
    countryIncorporated: z.nullable(z.string()),
    proprietorshipCategory: z.nullable(z.string()),
    registrationNo: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        address1: "address_1",
        address2: "address_2",
        address3: "address_3",
        companyName: "company_name",
        countryIncorporated: "country_incorporated",
        proprietorshipCategory: "proprietorship_category",
        registrationNo: "registration_no",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OwnershipCompany$;
(function (OwnershipCompany$) {
    /** @deprecated use `OwnershipCompany$inboundSchema` instead. */
    OwnershipCompany$.inboundSchema = exports.OwnershipCompany$inboundSchema;
    /** @deprecated use `OwnershipCompany$outboundSchema` instead. */
    OwnershipCompany$.outboundSchema = exports.OwnershipCompany$outboundSchema;
})(OwnershipCompany$ || (exports.OwnershipCompany$ = OwnershipCompany$ = {}));
function ownershipCompanyToJSON(ownershipCompany) {
    return JSON.stringify(exports.OwnershipCompany$outboundSchema.parse(ownershipCompany));
}
function ownershipCompanyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OwnershipCompany$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OwnershipCompany' from JSON`);
}
//# sourceMappingURL=ownershipcompany.js.map